exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cashbox-user__title[data-v-7e376776] {\n  margin: 12px 0;\n}\n.cashbox-user__actions[data-v-7e376776] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.cashbox-user__btn-close[data-v-7e376776] {\n  display: block;\n  margin-left: 0px;\n  margin-right: 1rem;\n  max-width: 15rem;\n}\n.span-account-id[data-v-7e376776] {\n  max-width: 10%;\n}\n.span-account-id-value[data-v-7e376776] {\n  width: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e376776","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/cashbox/index/Cashbox.User.vue
// module id = 2Pwk
// module chunks = 1